// useAiFeedDigest.js

import { useEffect, useRef } from 'react';

import { useUser } from 'context/UserContext';
import { useBase } from 'context/BaseContext';
import { requestAiFeedDigest } from 'spaces/services/AiFeedService';
import { resolveClientTimeZone } from 'spaces/utils/scheduleWindow';

export default function useAiFeedDigest({ enabled = true } = {}) {
  const { user, isEmailVerified } = useUser();
  const { activeBase } = useBase();
  const lastRequestedRef = useRef('');

  useEffect(() => {
    if (!enabled) return;

    const baseKey = String(activeBase?.key || '').trim();
    const userKey = String(user?.key || '').trim();

    if (!isEmailVerified || !baseKey || !userKey) return;

    const sessionKey = `${userKey}:${baseKey}`;
    if (lastRequestedRef.current === sessionKey) return;

    lastRequestedRef.current = sessionKey;

    requestAiFeedDigest({
      baseKey,
      timeZone: resolveClientTimeZone(),
    }).catch((error) => {
      console.error('[useAiFeedDigest] digest request failed:', error);
    });
  }, [activeBase?.key, enabled, isEmailVerified, user?.key]);
}
